import { NgbCalendarIslamicUmalqura } from "@ng-bootstrap/ng-bootstrap";
import { Action } from "@ngrx/store";
import { ProfesionalId, TotalCapita } from "src/common/menuUsuario";
import { MenuUsuarioActionTypes } from "./menu-usuario.actions";

export interface MenuUsuarioState {
	comprobanteTesoreriaReady: boolean
	comprobanteTesoreriaProfesionalIds: ProfesionalId[],
	capitaPacienteReady: boolean,
	capitaPacienteTotal: number,
	aportePlanSaludReady: boolean,
	aportePlanSaludYears: number[],
	idPersonaSelected: number
}

export const initialMenuUsuarioState: MenuUsuarioState = {
	comprobanteTesoreriaReady: true,
	comprobanteTesoreriaProfesionalIds: null,
	capitaPacienteReady: true,
	capitaPacienteTotal: null,
	aportePlanSaludReady: true,
	aportePlanSaludYears: null,
	idPersonaSelected: null
}

export function menuUsuarioReducer( state = initialMenuUsuarioState, action: Action ): MenuUsuarioState {
	switch( action.type ) {
		case MenuUsuarioActionTypes.AportePlanSaludInitRequested:
			return { ...state, aportePlanSaludReady: false };
		case MenuUsuarioActionTypes.AportePlanSaludInitLoaded:
			let years: number[] = action["payload"]["years"];
			return { ...state, aportePlanSaludYears: years, aportePlanSaludReady: true };
		case MenuUsuarioActionTypes.AportePlanSaludInitCancelled:
			return { ...state, aportePlanSaludYears: [], aportePlanSaludReady: true };
		case MenuUsuarioActionTypes.ComprobanteTesoreriaInitRequested:
			return { ...state, comprobanteTesoreriaReady: false };
		case MenuUsuarioActionTypes.ComprobanteTesoreriaInitLoaded:
			let comprobantesTesoreriaProfesionalIds: ProfesionalId[] = action["payload"]["profesionalIds"];
			return { ...state, comprobanteTesoreriaProfesionalIds: comprobantesTesoreriaProfesionalIds, comprobanteTesoreriaReady: true };
		case MenuUsuarioActionTypes.ComprobanteTesoreriaInitCancelled:
			return { ...state, comprobanteTesoreriaProfesionalIds: [], comprobanteTesoreriaReady: true };

		case MenuUsuarioActionTypes.CapitaPacienteInitRequested:
			return { ...state, capitaPacienteReady: false };
		case MenuUsuarioActionTypes.CapitaPacienteInitLoaded:
			let total: number = action["payload"]["total"];
			return { ...state, capitaPacienteTotal: total, capitaPacienteReady: true };
		case MenuUsuarioActionTypes.CapitaPacienteInitCancelled:
			return { ...state, capitaPacienteTotal: 0, capitaPacienteReady: true }

		case MenuUsuarioActionTypes.IdPersonaSelectedChanged:
			let idPersona: number = action["payload"]["idPersona"];
			return { ...state, idPersonaSelected: idPersona };

		default:
			return state;
	}
}